module.exports = __webpack_public_path__ + "static/media/scorecardSlider3.eda62c6b.jpg";